export default __webpack_public_path__ + "static/media/192.db8a4898.jpg";